'use client'

/* Own file for the translation of components. This is required because they're used in the widget and it cannot have dependencies to any API related code. */

import { useTranslation } from 'react-i18next'

export function useComponentTranslation() {
    return useTranslation(['common', 'components'], { nsMode: 'fallback' })
}
